module.exports = __webpack_public_path__ + "media/images/icon/allow_green-2ca8345854411f769e70efe12158093d.png";